import moment from 'moment';

export const formatDateTime = {
  isSelectableDate: (date) => {
    const today = new Date();
    const dInput = date.toDate();
    const dInputTime = dInput.getTime() / 86400000;
    const todayTime = today.getTime() / 86400000;
    return parseInt(dInputTime) >= parseInt(todayTime);
  },

  syncDateTime: (dateTimeMode, store) => {
    const now = moment();
    const date = now.format('YYYY-MM-DD');
    const nextHour = moment(now).add(1, 'hour');
    const time = dateTimeMode === 'now'
      ? now.format('HH:mm')
      : nextHour.format('HH:00');
    const formatDate = store?.format_date || 'DD/MM/YYYY';
    const formatTime = store?.format_time || 'HH:mm';
    return {
      date,
      time,
      datepicker: moment(date).format(formatDate),
      timepicker: moment(time, 'HH:mm').format(formatTime),
      sendDate: `${date} ${time}`,
      sendDateTmp: Math.floor(moment(`${date} ${time}`).valueOf() / 1000)
    };
  },

  formatDisplayDateTime: (dateStr, dateFormat, timeFormat) => {
    const momentDate = moment(dateStr);
    if (!momentDate.isValid()) {
      return '';
    }
    const formattedDate = momentDate.format(dateFormat);
    const formattedTime = momentDate.format(timeFormat);
    return `${formattedDate} à ${formattedTime}`;
  },
  formatDisplayDate: (dateStr, dateFormat, inputFormat = null) => {
    let momentDate;

    if (inputFormat) {
      momentDate = moment(dateStr, inputFormat);
    } else {
      momentDate = moment(dateStr);
    }

    if (!momentDate.isValid()) {
      return '';
    }
    return momentDate.format(dateFormat);
  },
  formatDisplayTimeWithTimezone: (timeStr, timeFormat) => {
    const momentTime = moment(timeStr, 'HH:mm');
    if (!momentTime.isValid()) {
      return { time: '', timezone: '' };
    }
    const formattedTime = momentTime.format(timeFormat);
    const timezone = moment().format('Z');
    const gmtOffset = timezone.substring(0, 3);
    
    return {
      time: ` ${formattedTime}`,
      timezone: ` GMT${gmtOffset}`
    };
  },
  formatDisplayTime: (dateStr, timeFormat) => {
    const momentDate = moment(dateStr);
    if (!momentDate.isValid()) {
      return { time: '', timezone: '' };
    }
    
    const formattedTime = momentDate.format(timeFormat);
    const timezone = momentDate.format('Z'); 
    const gmtOffset = timezone.substring(0, 3); 
    
    return {
      time: ` ${formattedTime}`,
      timezone: ` GMT${gmtOffset}`
    };
  },
  handleDateChange: (newValue, store) => {
    const momentDate = moment(newValue, 'DD/MM/YYYY');
    if (!momentDate.isValid()) {
      return {
        date: moment().format('YYYY-MM-DD'),
        datepicker: moment().format('DD/MM/YYYY')
      };
    }
    const result = {
      date: momentDate.format('YYYY-MM-DD'),
      datepicker: momentDate.format('DD/MM/YYYY')
    };
    return result;
  },

  handleTimeChange: (newValue) => {
    const momentTime = moment(newValue, 'HH:mm');
    return {
      time: momentTime.format('HH:mm'),
      timepicker: momentTime.format('HH:mm')
    };
  }
};